class IconSet {
    #m;
    constructor(icons) { this.#m = new Map(Object.entries(icons)); }
    get(key) { return this.#m.get(key); }
    keys() { return this.#m.keys(); }
    values() { return this.#m.values(); }
    entries() { return this.#m.entries(); }
}
export const ui = new IconSet({
    'add-circle-fill': await import('./ui/add-circle-fill.js').then(m => m.default),
    'add-circle': await import('./ui/add-circle.js').then(m => m.default),
    'add': await import('./ui/add.js').then(m => m.default),
    'analyze-fill': await import('./ui/analyze-fill.js').then(m => m.default),
    'analyze': await import('./ui/analyze.js').then(m => m.default),
    'application-fill': await import('./ui/application-fill.js').then(m => m.default),
    'application': await import('./ui/application.js').then(m => m.default),
    'applications-fill': await import('./ui/applications-fill.js').then(m => m.default),
    'applications': await import('./ui/applications.js').then(m => m.default),
    'arrow-circle-down-fill': await import('./ui/arrow-circle-down-fill.js').then(m => m.default),
    'arrow-circle-down': await import('./ui/arrow-circle-down.js').then(m => m.default),
    'arrow-circle-left-fill': await import('./ui/arrow-circle-left-fill.js').then(m => m.default),
    'arrow-circle-left': await import('./ui/arrow-circle-left.js').then(m => m.default),
    'arrow-circle-right-fill': await import('./ui/arrow-circle-right-fill.js').then(m => m.default),
    'arrow-circle-right': await import('./ui/arrow-circle-right.js').then(m => m.default),
    'arrow-circle-up-fill': await import('./ui/arrow-circle-up-fill.js').then(m => m.default),
    'arrow-circle-up': await import('./ui/arrow-circle-up.js').then(m => m.default),
    'arrow-down': await import('./ui/arrow-down.js').then(m => m.default),
    'arrow-left': await import('./ui/arrow-left.js').then(m => m.default),
    'arrow-right': await import('./ui/arrow-right.js').then(m => m.default),
    'arrow-up': await import('./ui/arrow-up.js').then(m => m.default),
    'assessment-fill': await import('./ui/assessment-fill.js').then(m => m.default),
    'assessment': await import('./ui/assessment.js').then(m => m.default),
    'auto-light-dark-mode-fill': await import('./ui/auto-light-dark-mode-fill.js').then(m => m.default),
    'auto-light-dark-mode': await import('./ui/auto-light-dark-mode.js').then(m => m.default),
    'backup': await import('./ui/backup.js').then(m => m.default),
    'backwards': await import('./ui/backwards.js').then(m => m.default),
    'ban-fill': await import('./ui/ban-fill.js').then(m => m.default),
    'ban': await import('./ui/ban.js').then(m => m.default),
    'blueprint-fill': await import('./ui/blueprint-fill.js').then(m => m.default),
    'blueprint': await import('./ui/blueprint.js').then(m => m.default),
    'branch-fill': await import('./ui/branch-fill.js').then(m => m.default),
    'branch': await import('./ui/branch.js').then(m => m.default),
    'bug-fill': await import('./ui/bug-fill.js').then(m => m.default),
    'bug': await import('./ui/bug.js').then(m => m.default),
    'build-fill': await import('./ui/build-fill.js').then(m => m.default),
    'build': await import('./ui/build.js').then(m => m.default),
    'call-fill': await import('./ui/call-fill.js').then(m => m.default),
    'call': await import('./ui/call.js').then(m => m.default),
    'car-fill': await import('./ui/car-fill.js').then(m => m.default),
    'car': await import('./ui/car.js').then(m => m.default),
    'card-payment-fill': await import('./ui/card-payment-fill.js').then(m => m.default),
    'card-payment': await import('./ui/card-payment.js').then(m => m.default),
    'caret-down-fill': await import('./ui/caret-down-fill.js').then(m => m.default),
    'caret-down': await import('./ui/caret-down.js').then(m => m.default),
    'caret-left-fill': await import('./ui/caret-left-fill.js').then(m => m.default),
    'caret-left': await import('./ui/caret-left.js').then(m => m.default),
    'caret-right-fill': await import('./ui/caret-right-fill.js').then(m => m.default),
    'caret-right': await import('./ui/caret-right.js').then(m => m.default),
    'caret-up-fill': await import('./ui/caret-up-fill.js').then(m => m.default),
    'caret-up': await import('./ui/caret-up.js').then(m => m.default),
    'check-circle-fill': await import('./ui/check-circle-fill.js').then(m => m.default),
    'check-circle': await import('./ui/check-circle.js').then(m => m.default),
    'check': await import('./ui/check.js').then(m => m.default),
    'checkup-fill': await import('./ui/checkup-fill.js').then(m => m.default),
    'checkup': await import('./ui/checkup.js').then(m => m.default),
    'circuit-fill': await import('./ui/circuit-fill.js').then(m => m.default),
    'circuit': await import('./ui/circuit.js').then(m => m.default),
    'clock-fill': await import('./ui/clock-fill.js').then(m => m.default),
    'clock': await import('./ui/clock.js').then(m => m.default),
    'close-circle-fill': await import('./ui/close-circle-fill.js').then(m => m.default),
    'close-circle': await import('./ui/close-circle.js').then(m => m.default),
    'close': await import('./ui/close.js').then(m => m.default),
    'cloud-download-fill': await import('./ui/cloud-download-fill.js').then(m => m.default),
    'cloud-download': await import('./ui/cloud-download.js').then(m => m.default),
    'cloud-edge-fill': await import('./ui/cloud-edge-fill.js').then(m => m.default),
    'cloud-edge': await import('./ui/cloud-edge.js').then(m => m.default),
    'cloud-fill': await import('./ui/cloud-fill.js').then(m => m.default),
    'cloud-upload-fill': await import('./ui/cloud-upload-fill.js').then(m => m.default),
    'cloud-upload': await import('./ui/cloud-upload.js').then(m => m.default),
    'cloud': await import('./ui/cloud.js').then(m => m.default),
    'code': await import('./ui/code.js').then(m => m.default),
    'collection-fill': await import('./ui/collection-fill.js').then(m => m.default),
    'collection': await import('./ui/collection.js').then(m => m.default),
    'combine-fill': await import('./ui/combine-fill.js').then(m => m.default),
    'combine': await import('./ui/combine.js').then(m => m.default),
    'comment-fill': await import('./ui/comment-fill.js').then(m => m.default),
    'comment': await import('./ui/comment.js').then(m => m.default),
    'compare-fill': await import('./ui/compare-fill.js').then(m => m.default),
    'compare': await import('./ui/compare.js').then(m => m.default),
    'compress': await import('./ui/compress.js').then(m => m.default),
    'connected-fill': await import('./ui/connected-fill.js').then(m => m.default),
    'connected': await import('./ui/connected.js').then(m => m.default),
    'construction-fill': await import('./ui/construction-fill.js').then(m => m.default),
    'construction': await import('./ui/construction.js').then(m => m.default),
    'controls': await import('./ui/controls.js').then(m => m.default),
    'copy-fill': await import('./ui/copy-fill.js').then(m => m.default),
    'copy': await import('./ui/copy.js').then(m => m.default),
    'cubes-fill': await import('./ui/cubes-fill.js').then(m => m.default),
    'cubes': await import('./ui/cubes.js').then(m => m.default),
    'dark-mode-fill': await import('./ui/dark-mode-fill.js').then(m => m.default),
    'dark-mode': await import('./ui/dark-mode.js').then(m => m.default),
    'data': await import('./ui/data.js').then(m => m.default),
    'decreasing-fill': await import('./ui/decreasing-fill.js').then(m => m.default),
    'decreasing': await import('./ui/decreasing.js').then(m => m.default),
    'desktop-fill': await import('./ui/desktop-fill.js').then(m => m.default),
    'desktop': await import('./ui/desktop.js').then(m => m.default),
    'disconnected': await import('./ui/disconnected.js').then(m => m.default),
    'dislike-fill': await import('./ui/dislike-fill.js').then(m => m.default),
    'dislike': await import('./ui/dislike.js').then(m => m.default),
    'distribute': await import('./ui/distribute.js').then(m => m.default),
    'document-fill': await import('./ui/document-fill.js').then(m => m.default),
    'document': await import('./ui/document.js').then(m => m.default),
    'double-caret-down-fill': await import('./ui/double-caret-down-fill.js').then(m => m.default),
    'double-caret-down': await import('./ui/double-caret-down.js').then(m => m.default),
    'double-caret-left-fill': await import('./ui/double-caret-left-fill.js').then(m => m.default),
    'double-caret-left': await import('./ui/double-caret-left.js').then(m => m.default),
    'double-caret-right-fill': await import('./ui/double-caret-right-fill.js').then(m => m.default),
    'double-caret-right': await import('./ui/double-caret-right.js').then(m => m.default),
    'double-caret-up-fill': await import('./ui/double-caret-up-fill.js').then(m => m.default),
    'double-caret-up': await import('./ui/double-caret-up.js').then(m => m.default),
    'download': await import('./ui/download.js').then(m => m.default),
    'duplicate-fill': await import('./ui/duplicate-fill.js').then(m => m.default),
    'duplicate': await import('./ui/duplicate.js').then(m => m.default),
    'edit-fill': await import('./ui/edit-fill.js').then(m => m.default),
    'edit': await import('./ui/edit.js').then(m => m.default),
    'electricity-fill': await import('./ui/electricity-fill.js').then(m => m.default),
    'electricity': await import('./ui/electricity.js').then(m => m.default),
    'ellipsis-horizontal-fill': await import('./ui/ellipsis-horizontal-fill.js').then(m => m.default),
    'ellipsis-horizontal': await import('./ui/ellipsis-horizontal.js').then(m => m.default),
    'ellipsis-vertical-fill': await import('./ui/ellipsis-vertical-fill.js').then(m => m.default),
    'ellipsis-vertical': await import('./ui/ellipsis-vertical.js').then(m => m.default),
    'embed-fill': await import('./ui/embed-fill.js').then(m => m.default),
    'embed': await import('./ui/embed.js').then(m => m.default),
    'enhancement-fill': await import('./ui/enhancement-fill.js').then(m => m.default),
    'enhancement': await import('./ui/enhancement.js').then(m => m.default),
    'error-fill': await import('./ui/error-fill.js').then(m => m.default),
    'error': await import('./ui/error.js').then(m => m.default),
    'ethernet-fill': await import('./ui/ethernet-fill.js').then(m => m.default),
    'ethernet': await import('./ui/ethernet.js').then(m => m.default),
    'expand': await import('./ui/expand.js').then(m => m.default),
    'experimental': await import('./ui/experimental.js').then(m => m.default),
    'export-fill': await import('./ui/export-fill.js').then(m => m.default),
    'export': await import('./ui/export.js').then(m => m.default),
    'external-link-fill': await import('./ui/external-link-fill.js').then(m => m.default),
    'external-link': await import('./ui/external-link.js').then(m => m.default),
    'filter-fill': await import('./ui/filter-fill.js').then(m => m.default),
    'filter': await import('./ui/filter.js').then(m => m.default),
    'flag-fill': await import('./ui/flag-fill.js').then(m => m.default),
    'flag': await import('./ui/flag.js').then(m => m.default),
    'folder-fill': await import('./ui/folder-fill.js').then(m => m.default),
    'folder': await import('./ui/folder.js').then(m => m.default),
    'forward': await import('./ui/forward.js').then(m => m.default),
    'government-fill': await import('./ui/government-fill.js').then(m => m.default),
    'government': await import('./ui/government.js').then(m => m.default),
    'graduation-fill': await import('./ui/graduation-fill.js').then(m => m.default),
    'graduation': await import('./ui/graduation.js').then(m => m.default),
    'grip-horizontal-fill': await import('./ui/grip-horizontal-fill.js').then(m => m.default),
    'grip-horizontal': await import('./ui/grip-horizontal.js').then(m => m.default),
    'grip-vertical-fill': await import('./ui/grip-vertical-fill.js').then(m => m.default),
    'grip-vertical': await import('./ui/grip-vertical.js').then(m => m.default),
    'harvey-ball-0': await import('./ui/harvey-ball-0.js').then(m => m.default),
    'harvey-ball-10': await import('./ui/harvey-ball-10.js').then(m => m.default),
    'harvey-ball-100': await import('./ui/harvey-ball-100.js').then(m => m.default),
    'harvey-ball-20': await import('./ui/harvey-ball-20.js').then(m => m.default),
    'harvey-ball-25': await import('./ui/harvey-ball-25.js').then(m => m.default),
    'harvey-ball-30': await import('./ui/harvey-ball-30.js').then(m => m.default),
    'harvey-ball-33': await import('./ui/harvey-ball-33.js').then(m => m.default),
    'harvey-ball-40': await import('./ui/harvey-ball-40.js').then(m => m.default),
    'harvey-ball-50': await import('./ui/harvey-ball-50.js').then(m => m.default),
    'harvey-ball-60': await import('./ui/harvey-ball-60.js').then(m => m.default),
    'harvey-ball-66': await import('./ui/harvey-ball-66.js').then(m => m.default),
    'harvey-ball-70': await import('./ui/harvey-ball-70.js').then(m => m.default),
    'harvey-ball-75': await import('./ui/harvey-ball-75.js').then(m => m.default),
    'harvey-ball-80': await import('./ui/harvey-ball-80.js').then(m => m.default),
    'harvey-ball-90': await import('./ui/harvey-ball-90.js').then(m => m.default),
    'harvey-ball-lower-50': await import('./ui/harvey-ball-lower-50.js').then(m => m.default),
    'harvey-ball-upper-50': await import('./ui/harvey-ball-upper-50.js').then(m => m.default),
    'history': await import('./ui/history.js').then(m => m.default),
    'home-fill': await import('./ui/home-fill.js').then(m => m.default),
    'home': await import('./ui/home.js').then(m => m.default),
    'hourglass': await import('./ui/hourglass.js').then(m => m.default),
    'hybrid-cloud-fill': await import('./ui/hybrid-cloud-fill.js').then(m => m.default),
    'hybrid-cloud': await import('./ui/hybrid-cloud.js').then(m => m.default),
    'in-progress': await import('./ui/in-progress.js').then(m => m.default),
    'increasing-fill': await import('./ui/increasing-fill.js').then(m => m.default),
    'increasing': await import('./ui/increasing.js').then(m => m.default),
    'information-fill': await import('./ui/information-fill.js').then(m => m.default),
    'information': await import('./ui/information.js').then(m => m.default),
    'insight-fill': await import('./ui/insight-fill.js').then(m => m.default),
    'insight': await import('./ui/insight.js').then(m => m.default),
    'install-fill': await import('./ui/install-fill.js').then(m => m.default),
    'install': await import('./ui/install.js').then(m => m.default),
    'key-fill': await import('./ui/key-fill.js').then(m => m.default),
    'key': await import('./ui/key.js').then(m => m.default),
    'lab-fill': await import('./ui/lab-fill.js').then(m => m.default),
    'lab': await import('./ui/lab.js').then(m => m.default),
    'language-fill': await import('./ui/language-fill.js').then(m => m.default),
    'language': await import('./ui/language.js').then(m => m.default),
    'light-mode-fill': await import('./ui/light-mode-fill.js').then(m => m.default),
    'light-mode': await import('./ui/light-mode.js').then(m => m.default),
    'like-fill': await import('./ui/like-fill.js').then(m => m.default),
    'like': await import('./ui/like.js').then(m => m.default),
    'link-broken': await import('./ui/link-broken.js').then(m => m.default),
    'link': await import('./ui/link.js').then(m => m.default),
    'liquid-fill': await import('./ui/liquid-fill.js').then(m => m.default),
    'liquid': await import('./ui/liquid.js').then(m => m.default),
    'list': await import('./ui/list.js').then(m => m.default),
    'lock-fill': await import('./ui/lock-fill.js').then(m => m.default),
    'lock': await import('./ui/lock.js').then(m => m.default),
    'long-arrow-down': await import('./ui/long-arrow-down.js').then(m => m.default),
    'long-arrow-left': await import('./ui/long-arrow-left.js').then(m => m.default),
    'long-arrow-right': await import('./ui/long-arrow-right.js').then(m => m.default),
    'long-arrow-up': await import('./ui/long-arrow-up.js').then(m => m.default),
    'loop': await import('./ui/loop.js').then(m => m.default),
    'mail-fill': await import('./ui/mail-fill.js').then(m => m.default),
    'mail': await import('./ui/mail.js').then(m => m.default),
    'manufacturing-fill': await import('./ui/manufacturing-fill.js').then(m => m.default),
    'manufacturing': await import('./ui/manufacturing.js').then(m => m.default),
    'menu-bars': await import('./ui/menu-bars.js').then(m => m.default),
    'migrate': await import('./ui/migrate.js').then(m => m.default),
    'minus-circle-fill': await import('./ui/minus-circle-fill.js').then(m => m.default),
    'minus-circle': await import('./ui/minus-circle.js').then(m => m.default),
    'minus': await import('./ui/minus.js').then(m => m.default),
    'mute-fill': await import('./ui/mute-fill.js').then(m => m.default),
    'mute': await import('./ui/mute.js').then(m => m.default),
    'new-fill': await import('./ui/new-fill.js').then(m => m.default),
    'new': await import('./ui/new.js').then(m => m.default),
    'notification-active-fill': await import('./ui/notification-active-fill.js').then(m => m.default),
    'notification-active': await import('./ui/notification-active.js').then(m => m.default),
    'notification-fill': await import('./ui/notification-fill.js').then(m => m.default),
    'notification': await import('./ui/notification.js').then(m => m.default),
    'off-fill': await import('./ui/off-fill.js').then(m => m.default),
    'off': await import('./ui/off.js').then(m => m.default),
    'pause-circle-fill': await import('./ui/pause-circle-fill.js').then(m => m.default),
    'pause-circle': await import('./ui/pause-circle.js').then(m => m.default),
    'pause-fill': await import('./ui/pause-fill.js').then(m => m.default),
    'pause': await import('./ui/pause.js').then(m => m.default),
    'pending': await import('./ui/pending.js').then(m => m.default),
    'pie-chart-fill': await import('./ui/pie-chart-fill.js').then(m => m.default),
    'pie-chart': await import('./ui/pie-chart.js').then(m => m.default),
    'platform-fill': await import('./ui/platform-fill.js').then(m => m.default),
    'platform': await import('./ui/platform.js').then(m => m.default),
    'play-circle-fill': await import('./ui/play-circle-fill.js').then(m => m.default),
    'play-circle': await import('./ui/play-circle.js').then(m => m.default),
    'play-fill': await import('./ui/play-fill.js').then(m => m.default),
    'play': await import('./ui/play.js').then(m => m.default),
    'print-fill': await import('./ui/print-fill.js').then(m => m.default),
    'print': await import('./ui/print.js').then(m => m.default),
    'profile-fill': await import('./ui/profile-fill.js').then(m => m.default),
    'profile': await import('./ui/profile.js').then(m => m.default),
    'publish': await import('./ui/publish.js').then(m => m.default),
    'puzzle-piece-fill': await import('./ui/puzzle-piece-fill.js').then(m => m.default),
    'puzzle-piece': await import('./ui/puzzle-piece.js').then(m => m.default),
    'question-mark-circle-fill': await import('./ui/question-mark-circle-fill.js').then(m => m.default),
    'question-mark-circle': await import('./ui/question-mark-circle.js').then(m => m.default),
    'question-mark': await import('./ui/question-mark.js').then(m => m.default),
    'redo': await import('./ui/redo.js').then(m => m.default),
    'refresh': await import('./ui/refresh.js').then(m => m.default),
    'resource-fill': await import('./ui/resource-fill.js').then(m => m.default),
    'resource': await import('./ui/resource.js').then(m => m.default),
    'resources-almost-empty': await import('./ui/resources-almost-empty.js').then(m => m.default),
    'resources-almost-full': await import('./ui/resources-almost-full.js').then(m => m.default),
    'resources-empty': await import('./ui/resources-empty.js').then(m => m.default),
    'resources-full': await import('./ui/resources-full.js').then(m => m.default),
    'rss-fill': await import('./ui/rss-fill.js').then(m => m.default),
    'rss': await import('./ui/rss.js').then(m => m.default),
    'search': await import('./ui/search.js').then(m => m.default),
    'secured-fill': await import('./ui/secured-fill.js').then(m => m.default),
    'secured': await import('./ui/secured.js').then(m => m.default),
    'security-advisory-fill': await import('./ui/security-advisory-fill.js').then(m => m.default),
    'security-advisory': await import('./ui/security-advisory.js').then(m => m.default),
    'security-fill': await import('./ui/security-fill.js').then(m => m.default),
    'security': await import('./ui/security.js').then(m => m.default),
    'server-fill': await import('./ui/server-fill.js').then(m => m.default),
    'server-stack-fill': await import('./ui/server-stack-fill.js').then(m => m.default),
    'server-stack': await import('./ui/server-stack.js').then(m => m.default),
    'server-upload-fill': await import('./ui/server-upload-fill.js').then(m => m.default),
    'server-upload': await import('./ui/server-upload.js').then(m => m.default),
    'server': await import('./ui/server.js').then(m => m.default),
    'settings-fill': await import('./ui/settings-fill.js').then(m => m.default),
    'settings': await import('./ui/settings.js').then(m => m.default),
    'share-fill': await import('./ui/share-fill.js').then(m => m.default),
    'share': await import('./ui/share.js').then(m => m.default),
    'sort-down-large-to-small': await import('./ui/sort-down-large-to-small.js').then(m => m.default),
    'sort-down-small-to-large': await import('./ui/sort-down-small-to-large.js').then(m => m.default),
    'sort-up-large-to-small': await import('./ui/sort-up-large-to-small.js').then(m => m.default),
    'sort-up-small-to-large': await import('./ui/sort-up-small-to-large.js').then(m => m.default),
    'star-fill': await import('./ui/star-fill.js').then(m => m.default),
    'star': await import('./ui/star.js').then(m => m.default),
    'storage-fill': await import('./ui/storage-fill.js').then(m => m.default),
    'storage': await import('./ui/storage.js').then(m => m.default),
    'swap-right-left': await import('./ui/swap-right-left.js').then(m => m.default),
    'swap-up-down': await import('./ui/swap-up-down.js').then(m => m.default),
    'switcher-menu': await import('./ui/switcher-menu.js').then(m => m.default),
    'sync': await import('./ui/sync.js').then(m => m.default),
    'table-fill': await import('./ui/table-fill.js').then(m => m.default),
    'table': await import('./ui/table.js').then(m => m.default),
    'tag-fill': await import('./ui/tag-fill.js').then(m => m.default),
    'tag': await import('./ui/tag.js').then(m => m.default),
    'topology-fill': await import('./ui/topology-fill.js').then(m => m.default),
    'topology': await import('./ui/topology.js').then(m => m.default),
    'trash-fill': await import('./ui/trash-fill.js').then(m => m.default),
    'trash': await import('./ui/trash.js').then(m => m.default),
    'travel-fill': await import('./ui/travel-fill.js').then(m => m.default),
    'travel': await import('./ui/travel.js').then(m => m.default),
    'truck-fill': await import('./ui/truck-fill.js').then(m => m.default),
    'truck': await import('./ui/truck.js').then(m => m.default),
    'undo': await import('./ui/undo.js').then(m => m.default),
    'unknown-fill': await import('./ui/unknown-fill.js').then(m => m.default),
    'unknown': await import('./ui/unknown.js').then(m => m.default),
    'unlock-fill': await import('./ui/unlock-fill.js').then(m => m.default),
    'unlock': await import('./ui/unlock.js').then(m => m.default),
    'unsecured-fill': await import('./ui/unsecured-fill.js').then(m => m.default),
    'unsecured': await import('./ui/unsecured.js').then(m => m.default),
    'upload': await import('./ui/upload.js').then(m => m.default),
    'users-fill': await import('./ui/users-fill.js').then(m => m.default),
    'users': await import('./ui/users.js').then(m => m.default),
    'view-fill': await import('./ui/view-fill.js').then(m => m.default),
    'view-off-fill': await import('./ui/view-off-fill.js').then(m => m.default),
    'view-off': await import('./ui/view-off.js').then(m => m.default),
    'view': await import('./ui/view.js').then(m => m.default),
    'virtual-server-fill': await import('./ui/virtual-server-fill.js').then(m => m.default),
    'virtual-server': await import('./ui/virtual-server.js').then(m => m.default),
    'volume-down-fill': await import('./ui/volume-down-fill.js').then(m => m.default),
    'volume-down': await import('./ui/volume-down.js').then(m => m.default),
    'volume-up-fill': await import('./ui/volume-up-fill.js').then(m => m.default),
    'volume-up': await import('./ui/volume-up.js').then(m => m.default),
    'warning-fill': await import('./ui/warning-fill.js').then(m => m.default),
    'warning': await import('./ui/warning.js').then(m => m.default),
    'window-fill': await import('./ui/window-fill.js').then(m => m.default),
    'window': await import('./ui/window.js').then(m => m.default),
});
export const standard = new IconSet({
    '5g': await import('./standard/5g.js').then(m => m.default),
    'acorn': await import('./standard/acorn.js').then(m => m.default),
    'agile-integration': await import('./standard/agile-integration.js').then(m => m.default),
    'agile': await import('./standard/agile.js').then(m => m.default),
    'ai-ml': await import('./standard/ai-ml.js').then(m => m.default),
    'air-filter': await import('./standard/air-filter.js').then(m => m.default),
    'alert': await import('./standard/alert.js').then(m => m.default),
    'amp': await import('./standard/amp.js').then(m => m.default),
    'analysis': await import('./standard/analysis.js').then(m => m.default),
    'anchor': await import('./standard/anchor.js').then(m => m.default),
    'api': await import('./standard/api.js').then(m => m.default),
    'app-mobile': await import('./standard/app-mobile.js').then(m => m.default),
    'app-on-server': await import('./standard/app-on-server.js').then(m => m.default),
    'app-secured': await import('./standard/app-secured.js').then(m => m.default),
    'app-unsecured': await import('./standard/app-unsecured.js').then(m => m.default),
    'app-update': await import('./standard/app-update.js').then(m => m.default),
    'app': await import('./standard/app.js').then(m => m.default),
    'apple-core': await import('./standard/apple-core.js').then(m => m.default),
    'apps-multiple-secured': await import('./standard/apps-multiple-secured.js').then(m => m.default),
    'apps-multiple-unsecured': await import('./standard/apps-multiple-unsecured.js').then(m => m.default),
    'apps-multiple': await import('./standard/apps-multiple.js').then(m => m.default),
    'architect': await import('./standard/architect.js').then(m => m.default),
    'architecture': await import('./standard/architecture.js').then(m => m.default),
    'arrow-directional': await import('./standard/arrow-directional.js').then(m => m.default),
    'assigned-desk': await import('./standard/assigned-desk.js').then(m => m.default),
    'atm': await import('./standard/atm.js').then(m => m.default),
    'atom': await import('./standard/atom.js').then(m => m.default),
    'automation': await import('./standard/automation.js').then(m => m.default),
    'award-ribbon': await import('./standard/award-ribbon.js').then(m => m.default),
    'backlog': await import('./standard/backlog.js').then(m => m.default),
    'backup-recovery': await import('./standard/backup-recovery.js').then(m => m.default),
    'bandage': await import('./standard/bandage.js').then(m => m.default),
    'bank-safe': await import('./standard/bank-safe.js').then(m => m.default),
    'bar-graph': await import('./standard/bar-graph.js').then(m => m.default),
    'barn': await import('./standard/barn.js').then(m => m.default),
    'battery': await import('./standard/battery.js').then(m => m.default),
    'beaker': await import('./standard/beaker.js').then(m => m.default),
    'beehive': await import('./standard/beehive.js').then(m => m.default),
    'binoculars': await import('./standard/binoculars.js').then(m => m.default),
    'bird': await import('./standard/bird.js').then(m => m.default),
    'blank-space': await import('./standard/blank-space.js').then(m => m.default),
    'blog': await import('./standard/blog.js').then(m => m.default),
    'blood-drive': await import('./standard/blood-drive.js').then(m => m.default),
    'blueprints': await import('./standard/blueprints.js').then(m => m.default),
    'boba-tea': await import('./standard/boba-tea.js').then(m => m.default),
    'book': await import('./standard/book.js').then(m => m.default),
    'bookmark': await import('./standard/bookmark.js').then(m => m.default),
    'books-multiple': await import('./standard/books-multiple.js').then(m => m.default),
    'bottle-plastic': await import('./standard/bottle-plastic.js').then(m => m.default),
    'box': await import('./standard/box.js').then(m => m.default),
    'boxing-glove': await import('./standard/boxing-glove.js').then(m => m.default),
    'brain': await import('./standard/brain.js').then(m => m.default),
    'british-pound-decreasing': await import('./standard/british-pound-decreasing.js').then(m => m.default),
    'british-pound-increasing': await import('./standard/british-pound-increasing.js').then(m => m.default),
    'british-pound': await import('./standard/british-pound.js').then(m => m.default),
    'bucket': await import('./standard/bucket.js').then(m => m.default),
    'bug': await import('./standard/bug.js').then(m => m.default),
    'burndown-chart': await import('./standard/burndown-chart.js').then(m => m.default),
    'butterfly': await import('./standard/butterfly.js').then(m => m.default),
    'cactus': await import('./standard/cactus.js').then(m => m.default),
    'calculator': await import('./standard/calculator.js').then(m => m.default),
    'calendar': await import('./standard/calendar.js').then(m => m.default),
    'camera': await import('./standard/camera.js').then(m => m.default),
    'candle': await import('./standard/candle.js').then(m => m.default),
    'capitol-building': await import('./standard/capitol-building.js').then(m => m.default),
    'car-insurance': await import('./standard/car-insurance.js').then(m => m.default),
    'carrot': await import('./standard/carrot.js').then(m => m.default),
    'cart': await import('./standard/cart.js').then(m => m.default),
    'case-study': await import('./standard/case-study.js').then(m => m.default),
    'catalog': await import('./standard/catalog.js').then(m => m.default),
    'celebration': await import('./standard/celebration.js').then(m => m.default),
    'ceo-businessleader': await import('./standard/ceo-businessleader.js').then(m => m.default),
    'certification': await import('./standard/certification.js').then(m => m.default),
    'check': await import('./standard/check.js').then(m => m.default),
    'checkbox-blank': await import('./standard/checkbox-blank.js').then(m => m.default),
    'checkbox-checked': await import('./standard/checkbox-checked.js').then(m => m.default),
    'checkbox-indeterminate': await import('./standard/checkbox-indeterminate.js').then(m => m.default),
    'checklist': await import('./standard/checklist.js').then(m => m.default),
    'cheeseburger': await import('./standard/cheeseburger.js').then(m => m.default),
    'cio-itdm': await import('./standard/cio-itdm.js').then(m => m.default),
    'circuit': await import('./standard/circuit.js').then(m => m.default),
    'city': await import('./standard/city.js').then(m => m.default),
    'click': await import('./standard/click.js').then(m => m.default),
    'clipboard-checklist': await import('./standard/clipboard-checklist.js').then(m => m.default),
    'clock': await import('./standard/clock.js').then(m => m.default),
    'cloud-automation': await import('./standard/cloud-automation.js').then(m => m.default),
    'cloud-deploy': await import('./standard/cloud-deploy.js').then(m => m.default),
    'cloud-inspect': await import('./standard/cloud-inspect.js').then(m => m.default),
    'cloud-migration': await import('./standard/cloud-migration.js').then(m => m.default),
    'cloud-native-development': await import('./standard/cloud-native-development.js').then(m => m.default),
    'cloud-private': await import('./standard/cloud-private.js').then(m => m.default),
    'cloud-secured': await import('./standard/cloud-secured.js').then(m => m.default),
    'cloud-services': await import('./standard/cloud-services.js').then(m => m.default),
    'cloud-unsecured': await import('./standard/cloud-unsecured.js').then(m => m.default),
    'cloud-update': await import('./standard/cloud-update.js').then(m => m.default),
    'cloud': await import('./standard/cloud.js').then(m => m.default),
    'cluster': await import('./standard/cluster.js').then(m => m.default),
    'coaxial-cable': await import('./standard/coaxial-cable.js').then(m => m.default),
    'code': await import('./standard/code.js').then(m => m.default),
    'coffee-beans': await import('./standard/coffee-beans.js').then(m => m.default),
    'collaboration': await import('./standard/collaboration.js').then(m => m.default),
    'combustible': await import('./standard/combustible.js').then(m => m.default),
    'command-line': await import('./standard/command-line.js').then(m => m.default),
    'community-culture': await import('./standard/community-culture.js').then(m => m.default),
    'community-people': await import('./standard/community-people.js').then(m => m.default),
    'compass': await import('./standard/compass.js').then(m => m.default),
    'completed-product': await import('./standard/completed-product.js').then(m => m.default),
    'confidential': await import('./standard/confidential.js').then(m => m.default),
    'container-image': await import('./standard/container-image.js').then(m => m.default),
    'container-microservice': await import('./standard/container-microservice.js').then(m => m.default),
    'container-private': await import('./standard/container-private.js').then(m => m.default),
    'container-registry': await import('./standard/container-registry.js').then(m => m.default),
    'container-secured': await import('./standard/container-secured.js').then(m => m.default),
    'container-unsecured': await import('./standard/container-unsecured.js').then(m => m.default),
    'container': await import('./standard/container.js').then(m => m.default),
    'containerized-app': await import('./standard/containerized-app.js').then(m => m.default),
    'control-panel': await import('./standard/control-panel.js').then(m => m.default),
    'conversation': await import('./standard/conversation.js').then(m => m.default),
    'covered-dish': await import('./standard/covered-dish.js').then(m => m.default),
    'crab': await import('./standard/crab.js').then(m => m.default),
    'crawl-arrow': await import('./standard/crawl-arrow.js').then(m => m.default),
    'credit-card': await import('./standard/credit-card.js').then(m => m.default),
    'cricket-bats': await import('./standard/cricket-bats.js').then(m => m.default),
    'cross-functional-collaboration': await import('./standard/cross-functional-collaboration.js').then(m => m.default),
    'cross': await import('./standard/cross.js').then(m => m.default),
    'cup': await import('./standard/cup.js').then(m => m.default),
    'data-connections': await import('./standard/data-connections.js').then(m => m.default),
    'data': await import('./standard/data.js').then(m => m.default),
    'datacenter': await import('./standard/datacenter.js').then(m => m.default),
    'ddr-memory': await import('./standard/ddr-memory.js').then(m => m.default),
    'deployed-model': await import('./standard/deployed-model.js').then(m => m.default),
    'developer': await import('./standard/developer.js').then(m => m.default),
    'development-model': await import('./standard/development-model.js').then(m => m.default),
    'devops': await import('./standard/devops.js').then(m => m.default),
    'digital-assessment': await import('./standard/digital-assessment.js').then(m => m.default),
    'digital-standup': await import('./standard/digital-standup.js').then(m => m.default),
    'digital-transformation': await import('./standard/digital-transformation.js').then(m => m.default),
    'disc': await import('./standard/disc.js').then(m => m.default),
    'dishes': await import('./standard/dishes.js').then(m => m.default),
    'dishwasher': await import('./standard/dishwasher.js').then(m => m.default),
    'disruption': await import('./standard/disruption.js').then(m => m.default),
    'dollar-sign-decreasing': await import('./standard/dollar-sign-decreasing.js').then(m => m.default),
    'dollar-sign-increasing': await import('./standard/dollar-sign-increasing.js').then(m => m.default),
    'dollar-sign': await import('./standard/dollar-sign.js').then(m => m.default),
    'donut': await import('./standard/donut.js').then(m => m.default),
    'download': await import('./standard/download.js').then(m => m.default),
    'drone': await import('./standard/drone.js').then(m => m.default),
    'ear': await import('./standard/ear.js').then(m => m.default),
    'ebook': await import('./standard/ebook.js').then(m => m.default),
    'edge': await import('./standard/edge.js').then(m => m.default),
    'electrical-bolt': await import('./standard/electrical-bolt.js').then(m => m.default),
    'electrical-plug': await import('./standard/electrical-plug.js').then(m => m.default),
    'elevator': await import('./standard/elevator.js').then(m => m.default),
    'email': await import('./standard/email.js').then(m => m.default),
    'embedded': await import('./standard/embedded.js').then(m => m.default),
    'emergency-aed': await import('./standard/emergency-aed.js').then(m => m.default),
    'employee-badge': await import('./standard/employee-badge.js').then(m => m.default),
    'envelope-manilla': await import('./standard/envelope-manilla.js').then(m => m.default),
    'envelope': await import('./standard/envelope.js').then(m => m.default),
    'erlenmeyer-flask': await import('./standard/erlenmeyer-flask.js').then(m => m.default),
    'escalator-down': await import('./standard/escalator-down.js').then(m => m.default),
    'escalator-up': await import('./standard/escalator-up.js').then(m => m.default),
    'euro-decreasing': await import('./standard/euro-decreasing.js').then(m => m.default),
    'euro-increasing': await import('./standard/euro-increasing.js').then(m => m.default),
    'euro': await import('./standard/euro.js').then(m => m.default),
    'everything-as-a-service': await import('./standard/everything-as-a-service.js').then(m => m.default),
    'face-mask': await import('./standard/face-mask.js').then(m => m.default),
    'farm-tools': await import('./standard/farm-tools.js').then(m => m.default),
    'fast-forward': await import('./standard/fast-forward.js').then(m => m.default),
    'filter': await import('./standard/filter.js').then(m => m.default),
    'fingerprint': await import('./standard/fingerprint.js').then(m => m.default),
    'fire-extinguisher': await import('./standard/fire-extinguisher.js').then(m => m.default),
    'firewall-a': await import('./standard/firewall-a.js').then(m => m.default),
    'fish': await import('./standard/fish.js').then(m => m.default),
    'flag': await import('./standard/flag.js').then(m => m.default),
    'flight-helmet': await import('./standard/flight-helmet.js').then(m => m.default),
    'flowchart': await import('./standard/flowchart.js').then(m => m.default),
    'folder': await import('./standard/folder.js').then(m => m.default),
    'freezer': await import('./standard/freezer.js').then(m => m.default),
    'game-controller': await import('./standard/game-controller.js').then(m => m.default),
    'game-plan': await import('./standard/game-plan.js').then(m => m.default),
    'game-streaming': await import('./standard/game-streaming.js').then(m => m.default),
    'gateway': await import('./standard/gateway.js').then(m => m.default),
    'gear-group': await import('./standard/gear-group.js').then(m => m.default),
    'gear': await import('./standard/gear.js').then(m => m.default),
    'gift-box': await import('./standard/gift-box.js').then(m => m.default),
    'glass-bottle': await import('./standard/glass-bottle.js').then(m => m.default),
    'globe-abstract': await import('./standard/globe-abstract.js').then(m => m.default),
    'globe': await import('./standard/globe.js').then(m => m.default),
    'government': await import('./standard/government.js').then(m => m.default),
    'gpu': await import('./standard/gpu.js').then(m => m.default),
    'graduation-cap': await import('./standard/graduation-cap.js').then(m => m.default),
    'graph-exponential-down': await import('./standard/graph-exponential-down.js').then(m => m.default),
    'graph-exponential-up': await import('./standard/graph-exponential-up.js').then(m => m.default),
    'graph-line-up': await import('./standard/graph-line-up.js').then(m => m.default),
    'graph-pie': await import('./standard/graph-pie.js').then(m => m.default),
    'graph-steady-down': await import('./standard/graph-steady-down.js').then(m => m.default),
    'graph-steady-up': await import('./standard/graph-steady-up.js').then(m => m.default),
    'hand-closed': await import('./standard/hand-closed.js').then(m => m.default),
    'hand-fan': await import('./standard/hand-fan.js').then(m => m.default),
    'hand-open': await import('./standard/hand-open.js').then(m => m.default),
    'hand-pointing': await import('./standard/hand-pointing.js').then(m => m.default),
    'hand-sanitizer': await import('./standard/hand-sanitizer.js').then(m => m.default),
    'hand-thumbs-up': await import('./standard/hand-thumbs-up.js').then(m => m.default),
    'hand-waving': await import('./standard/hand-waving.js').then(m => m.default),
    'handshake': await import('./standard/handshake.js').then(m => m.default),
    'harvey-ball-0': await import('./standard/harvey-ball-0.js').then(m => m.default),
    'harvey-ball-10': await import('./standard/harvey-ball-10.js').then(m => m.default),
    'harvey-ball-100': await import('./standard/harvey-ball-100.js').then(m => m.default),
    'harvey-ball-20': await import('./standard/harvey-ball-20.js').then(m => m.default),
    'harvey-ball-25': await import('./standard/harvey-ball-25.js').then(m => m.default),
    'harvey-ball-30': await import('./standard/harvey-ball-30.js').then(m => m.default),
    'harvey-ball-33': await import('./standard/harvey-ball-33.js').then(m => m.default),
    'harvey-ball-40': await import('./standard/harvey-ball-40.js').then(m => m.default),
    'harvey-ball-50': await import('./standard/harvey-ball-50.js').then(m => m.default),
    'harvey-ball-60': await import('./standard/harvey-ball-60.js').then(m => m.default),
    'harvey-ball-66': await import('./standard/harvey-ball-66.js').then(m => m.default),
    'harvey-ball-70': await import('./standard/harvey-ball-70.js').then(m => m.default),
    'harvey-ball-75': await import('./standard/harvey-ball-75.js').then(m => m.default),
    'harvey-ball-80': await import('./standard/harvey-ball-80.js').then(m => m.default),
    'harvey-ball-90': await import('./standard/harvey-ball-90.js').then(m => m.default),
    'hat': await import('./standard/hat.js').then(m => m.default),
    'headphones': await import('./standard/headphones.js').then(m => m.default),
    'heart-monitor': await import('./standard/heart-monitor.js').then(m => m.default),
    'heart': await import('./standard/heart.js').then(m => m.default),
    'hierarchy': await import('./standard/hierarchy.js').then(m => m.default),
    'hiking-backpack': await import('./standard/hiking-backpack.js').then(m => m.default),
    'home': await import('./standard/home.js').then(m => m.default),
    'hourglass': await import('./standard/hourglass.js').then(m => m.default),
    'hybrid-cloud-infrastructure': await import('./standard/hybrid-cloud-infrastructure.js').then(m => m.default),
    'hypervisor': await import('./standard/hypervisor.js').then(m => m.default),
    'import': await import('./standard/import.js').then(m => m.default),
    'industry': await import('./standard/industry.js').then(m => m.default),
    'info': await import('./standard/info.js').then(m => m.default),
    'install': await import('./standard/install.js').then(m => m.default),
    'instructor': await import('./standard/instructor.js').then(m => m.default),
    'insurance': await import('./standard/insurance.js').then(m => m.default),
    'interoperability': await import('./standard/interoperability.js').then(m => m.default),
    'invoice-british-pound': await import('./standard/invoice-british-pound.js').then(m => m.default),
    'invoice-dollar-sign': await import('./standard/invoice-dollar-sign.js').then(m => m.default),
    'invoice-euro': await import('./standard/invoice-euro.js').then(m => m.default),
    'invoice-yen': await import('./standard/invoice-yen.js').then(m => m.default),
    'it-modernization': await import('./standard/it-modernization.js').then(m => m.default),
    'it-optimization': await import('./standard/it-optimization.js').then(m => m.default),
    'joystick-controller': await import('./standard/joystick-controller.js').then(m => m.default),
    'kanban': await import('./standard/kanban.js').then(m => m.default),
    'key': await import('./standard/key.js').then(m => m.default),
    'keyboard': await import('./standard/keyboard.js').then(m => m.default),
    'kite': await import('./standard/kite.js').then(m => m.default),
    'koala-admin': await import('./standard/koala-admin.js').then(m => m.default),
    'koala-kiosk': await import('./standard/koala-kiosk.js').then(m => m.default),
    'kubernetes-pod': await import('./standard/kubernetes-pod.js').then(m => m.default),
    'laptop-alert': await import('./standard/laptop-alert.js').then(m => m.default),
    'laptop-video-call': await import('./standard/laptop-video-call.js').then(m => m.default),
    'laptop-webinar': await import('./standard/laptop-webinar.js').then(m => m.default),
    'laptop': await import('./standard/laptop.js').then(m => m.default),
    'layered': await import('./standard/layered.js').then(m => m.default),
    'lifecycle': await import('./standard/lifecycle.js').then(m => m.default),
    'lifevest': await import('./standard/lifevest.js').then(m => m.default),
    'light-bulb': await import('./standard/light-bulb.js').then(m => m.default),
    'lighthouse': await import('./standard/lighthouse.js').then(m => m.default),
    'link-broken': await import('./standard/link-broken.js').then(m => m.default),
    'link': await import('./standard/link.js').then(m => m.default),
    'location-pin': await import('./standard/location-pin.js').then(m => m.default),
    'locker-assigned': await import('./standard/locker-assigned.js').then(m => m.default),
    'locker-day-use': await import('./standard/locker-day-use.js').then(m => m.default),
    'locker': await import('./standard/locker.js').then(m => m.default),
    'luggage': await import('./standard/luggage.js').then(m => m.default),
    'lungs': await import('./standard/lungs.js').then(m => m.default),
    'magnifying-glass': await import('./standard/magnifying-glass.js').then(m => m.default),
    'mailbox': await import('./standard/mailbox.js').then(m => m.default),
    'mainframe': await import('./standard/mainframe.js').then(m => m.default),
    'management-and-automation': await import('./standard/management-and-automation.js').then(m => m.default),
    'management': await import('./standard/management.js').then(m => m.default),
    'map': await import('./standard/map.js').then(m => m.default),
    'maze': await import('./standard/maze.js').then(m => m.default),
    'megaphone': await import('./standard/megaphone.js').then(m => m.default),
    'merge': await import('./standard/merge.js').then(m => m.default),
    'metal-can': await import('./standard/metal-can.js').then(m => m.default),
    'microphone': await import('./standard/microphone.js').then(m => m.default),
    'microservices': await import('./standard/microservices.js').then(m => m.default),
    'migration': await import('./standard/migration.js').then(m => m.default),
    'minimum-viable-product': await import('./standard/minimum-viable-product.js').then(m => m.default),
    'mobile-associate': await import('./standard/mobile-associate.js').then(m => m.default),
    'mobile-devices': await import('./standard/mobile-devices.js').then(m => m.default),
    'mobile-payment-british-pound': await import('./standard/mobile-payment-british-pound.js').then(m => m.default),
    'mobile-payment-dollar': await import('./standard/mobile-payment-dollar.js').then(m => m.default),
    'mobile-payment-euro': await import('./standard/mobile-payment-euro.js').then(m => m.default),
    'mobile-payment-yen': await import('./standard/mobile-payment-yen.js').then(m => m.default),
    'mobius-loop': await import('./standard/mobius-loop.js').then(m => m.default),
    'model-registry': await import('./standard/model-registry.js').then(m => m.default),
    'money-stack': await import('./standard/money-stack.js').then(m => m.default),
    'money': await import('./standard/money.js').then(m => m.default),
    'monitor-blank': await import('./standard/monitor-blank.js').then(m => m.default),
    'mountains': await import('./standard/mountains.js').then(m => m.default),
    'mouse': await import('./standard/mouse.js').then(m => m.default),
    'mug': await import('./standard/mug.js').then(m => m.default),
    'multi-cloud': await import('./standard/multi-cloud.js').then(m => m.default),
    'multiply': await import('./standard/multiply.js').then(m => m.default),
    'mushroom': await import('./standard/mushroom.js').then(m => m.default),
    'music-note': await import('./standard/music-note.js').then(m => m.default),
    'music-streaming': await import('./standard/music-streaming.js').then(m => m.default),
    'neighborhood': await import('./standard/neighborhood.js').then(m => m.default),
    'network-automation': await import('./standard/network-automation.js').then(m => m.default),
    'newspaper': await import('./standard/newspaper.js').then(m => m.default),
    'no-drink': await import('./standard/no-drink.js').then(m => m.default),
    'no-food': await import('./standard/no-food.js').then(m => m.default),
    'no-smoking': await import('./standard/no-smoking.js').then(m => m.default),
    'no': await import('./standard/no.js').then(m => m.default),
    'non-combustible': await import('./standard/non-combustible.js').then(m => m.default),
    'noodle-bowl': await import('./standard/noodle-bowl.js').then(m => m.default),
    'north-star': await import('./standard/north-star.js').then(m => m.default),
    'notepad': await import('./standard/notepad.js').then(m => m.default),
    'objects-phone-mobile': await import('./standard/objects-phone-mobile.js').then(m => m.default),
    'office': await import('./standard/office.js').then(m => m.default),
    'oil-and-gas': await import('./standard/oil-and-gas.js').then(m => m.default),
    'online-collaboration': await import('./standard/online-collaboration.js').then(m => m.default),
    'open-source': await import('./standard/open-source.js').then(m => m.default),
    'operations': await import('./standard/operations.js').then(m => m.default),
    'operator': await import('./standard/operator.js').then(m => m.default),
    'orchestration': await import('./standard/orchestration.js').then(m => m.default),
    'origami': await import('./standard/origami.js').then(m => m.default),
    'padlock-locked': await import('./standard/padlock-locked.js').then(m => m.default),
    'padlock-unlocked': await import('./standard/padlock-unlocked.js').then(m => m.default),
    'paint-roller': await import('./standard/paint-roller.js').then(m => m.default),
    'paper-blank': await import('./standard/paper-blank.js').then(m => m.default),
    'paper-clip': await import('./standard/paper-clip.js').then(m => m.default),
    'paper-lined': await import('./standard/paper-lined.js').then(m => m.default),
    'paper-stack-blank': await import('./standard/paper-stack-blank.js').then(m => m.default),
    'paper-stack-lined': await import('./standard/paper-stack-lined.js').then(m => m.default),
    'pass-through': await import('./standard/pass-through.js').then(m => m.default),
    'password-a': await import('./standard/password-a.js').then(m => m.default),
    'path': await import('./standard/path.js').then(m => m.default),
    'pause': await import('./standard/pause.js').then(m => m.default),
    'pen-tool': await import('./standard/pen-tool.js').then(m => m.default),
    'pen': await import('./standard/pen.js').then(m => m.default),
    'pencil': await import('./standard/pencil.js').then(m => m.default),
    'pet-paw-print': await import('./standard/pet-paw-print.js').then(m => m.default),
    'phone': await import('./standard/phone.js').then(m => m.default),
    'piggy-bank': await import('./standard/piggy-bank.js').then(m => m.default),
    'planning': await import('./standard/planning.js').then(m => m.default),
    'platform': await import('./standard/platform.js').then(m => m.default),
    'play': await import('./standard/play.js').then(m => m.default),
    'podium-presentation': await import('./standard/podium-presentation.js').then(m => m.default),
    'power': await import('./standard/power.js').then(m => m.default),
    'pricetag': await import('./standard/pricetag.js').then(m => m.default),
    'printer-copier': await import('./standard/printer-copier.js').then(m => m.default),
    'product-trial': await import('./standard/product-trial.js').then(m => m.default),
    'progression-linear': await import('./standard/progression-linear.js').then(m => m.default),
    'progression': await import('./standard/progression.js').then(m => m.default),
    'puzzle-piece': await import('./standard/puzzle-piece.js').then(m => m.default),
    'quantum-computing': await import('./standard/quantum-computing.js').then(m => m.default),
    'question-mark': await import('./standard/question-mark.js').then(m => m.default),
    'quotemark-close': await import('./standard/quotemark-close.js').then(m => m.default),
    'quotemark-open': await import('./standard/quotemark-open.js').then(m => m.default),
    'rainbow': await import('./standard/rainbow.js').then(m => m.default),
    'recycle': await import('./standard/recycle.js').then(m => m.default),
    'refrigerator': await import('./standard/refrigerator.js').then(m => m.default),
    'registered-model': await import('./standard/registered-model.js').then(m => m.default),
    'reminder': await import('./standard/reminder.js').then(m => m.default),
    'remote-associate': await import('./standard/remote-associate.js').then(m => m.default),
    'report': await import('./standard/report.js').then(m => m.default),
    'restrooms': await import('./standard/restrooms.js').then(m => m.default),
    'reusable-bag': await import('./standard/reusable-bag.js').then(m => m.default),
    'rewind': await import('./standard/rewind.js').then(m => m.default),
    'ribbon': await import('./standard/ribbon.js').then(m => m.default),
    'robot': await import('./standard/robot.js').then(m => m.default),
    'robotic-arm': await import('./standard/robotic-arm.js').then(m => m.default),
    'rockstar': await import('./standard/rockstar.js').then(m => m.default),
    'router-load-balancer-virtual': await import('./standard/router-load-balancer-virtual.js').then(m => m.default),
    'router-load-balancer': await import('./standard/router-load-balancer.js').then(m => m.default),
    'rugby-ball': await import('./standard/rugby-ball.js').then(m => m.default),
    'run-arrow': await import('./standard/run-arrow.js').then(m => m.default),
    'run-pipeline': await import('./standard/run-pipeline.js').then(m => m.default),
    'run-shoe': await import('./standard/run-shoe.js').then(m => m.default),
    'safety-goggles': await import('./standard/safety-goggles.js').then(m => m.default),
    'save': await import('./standard/save.js').then(m => m.default),
    'scalable': await import('./standard/scalable.js').then(m => m.default),
    'scale-growing': await import('./standard/scale-growing.js').then(m => m.default),
    'scale-shrinking': await import('./standard/scale-shrinking.js').then(m => m.default),
    'scale-unbalanced': await import('./standard/scale-unbalanced.js').then(m => m.default),
    'scales-of-justice': await import('./standard/scales-of-justice.js').then(m => m.default),
    'school': await import('./standard/school.js').then(m => m.default),
    'secured': await import('./standard/secured.js').then(m => m.default),
    'security-camera': await import('./standard/security-camera.js').then(m => m.default),
    'server-secured': await import('./standard/server-secured.js').then(m => m.default),
    'server-stack-secured': await import('./standard/server-stack-secured.js').then(m => m.default),
    'server-stack-unsecured': await import('./standard/server-stack-unsecured.js').then(m => m.default),
    'server-stack': await import('./standard/server-stack.js').then(m => m.default),
    'server-unsecured': await import('./standard/server-unsecured.js').then(m => m.default),
    'server': await import('./standard/server.js').then(m => m.default),
    'serverless': await import('./standard/serverless.js').then(m => m.default),
    'share': await import('./standard/share.js').then(m => m.default),
    'shared-workspace': await import('./standard/shared-workspace.js').then(m => m.default),
    'shark-fin': await import('./standard/shark-fin.js').then(m => m.default),
    'shield': await import('./standard/shield.js').then(m => m.default),
    'shoe': await import('./standard/shoe.js').then(m => m.default),
    'shower': await import('./standard/shower.js').then(m => m.default),
    'simplify': await import('./standard/simplify.js').then(m => m.default),
    'single-sign-on': await import('./standard/single-sign-on.js').then(m => m.default),
    'single-use-workspace': await import('./standard/single-use-workspace.js').then(m => m.default),
    'smartwatch': await import('./standard/smartwatch.js').then(m => m.default),
    'snowflake': await import('./standard/snowflake.js').then(m => m.default),
    'solar-power': await import('./standard/solar-power.js').then(m => m.default),
    'soup-can': await import('./standard/soup-can.js').then(m => m.default),
    'space-capsule': await import('./standard/space-capsule.js').then(m => m.default),
    'space-satellite': await import('./standard/space-satellite.js').then(m => m.default),
    'spray-bottle': await import('./standard/spray-bottle.js').then(m => m.default),
    'stairs': await import('./standard/stairs.js').then(m => m.default),
    'standup': await import('./standard/standup.js').then(m => m.default),
    'star': await import('./standard/star.js').then(m => m.default),
    'stock-market-down': await import('./standard/stock-market-down.js').then(m => m.default),
    'stock-market-up': await import('./standard/stock-market-up.js').then(m => m.default),
    'stopwatch': await import('./standard/stopwatch.js').then(m => m.default),
    'storage-classes': await import('./standard/storage-classes.js').then(m => m.default),
    'storage-stack': await import('./standard/storage-stack.js').then(m => m.default),
    'storage': await import('./standard/storage.js').then(m => m.default),
    'subscription': await import('./standard/subscription.js').then(m => m.default),
    'sun': await import('./standard/sun.js').then(m => m.default),
    'supplemental': await import('./standard/supplemental.js').then(m => m.default),
    'support': await import('./standard/support.js').then(m => m.default),
    'survey-rating': await import('./standard/survey-rating.js').then(m => m.default),
    'sustainability': await import('./standard/sustainability.js').then(m => m.default),
    'sustainable-energy': await import('./standard/sustainable-energy.js').then(m => m.default),
    'sustainable-power': await import('./standard/sustainable-power.js').then(m => m.default),
    'sys-admin': await import('./standard/sys-admin.js').then(m => m.default),
    'tablet': await import('./standard/tablet.js').then(m => m.default),
    'talk-bubble': await import('./standard/talk-bubble.js').then(m => m.default),
    'tape-measure': await import('./standard/tape-measure.js').then(m => m.default),
    'target': await import('./standard/target.js').then(m => m.default),
    'telco-cloud': await import('./standard/telco-cloud.js').then(m => m.default),
    'telecommunications': await import('./standard/telecommunications.js').then(m => m.default),
    'test-tube': await import('./standard/test-tube.js').then(m => m.default),
    'thermometer-cold': await import('./standard/thermometer-cold.js').then(m => m.default),
    'thermometer-hot': await import('./standard/thermometer-hot.js').then(m => m.default),
    'thought-bubble': await import('./standard/thought-bubble.js').then(m => m.default),
    'toolbox': await import('./standard/toolbox.js').then(m => m.default),
    'touchdown-area': await import('./standard/touchdown-area.js').then(m => m.default),
    'trail-signage': await import('./standard/trail-signage.js').then(m => m.default),
    'trashcan': await import('./standard/trashcan.js').then(m => m.default),
    'tree': await import('./standard/tree.js').then(m => m.default),
    'trophy': await import('./standard/trophy.js').then(m => m.default),
    'tropical-drink': await import('./standard/tropical-drink.js').then(m => m.default),
    'tshirt': await import('./standard/tshirt.js').then(m => m.default),
    'umbrella': await import('./standard/umbrella.js').then(m => m.default),
    'unsecured': await import('./standard/unsecured.js').then(m => m.default),
    'update': await import('./standard/update.js').then(m => m.default),
    'upload': await import('./standard/upload.js').then(m => m.default),
    'usb-flash-drive': await import('./standard/usb-flash-drive.js').then(m => m.default),
    'user-story': await import('./standard/user-story.js').then(m => m.default),
    'user': await import('./standard/user.js').then(m => m.default),
    'utensils': await import('./standard/utensils.js').then(m => m.default),
    'venn-diagram': await import('./standard/venn-diagram.js').then(m => m.default),
    'video-streaming': await import('./standard/video-streaming.js').then(m => m.default),
    'video': await import('./standard/video.js').then(m => m.default),
    'view': await import('./standard/view.js').then(m => m.default),
    'virtual-collaboration': await import('./standard/virtual-collaboration.js').then(m => m.default),
    'virtual-server-secured': await import('./standard/virtual-server-secured.js').then(m => m.default),
    'virtual-server-stack-secured': await import('./standard/virtual-server-stack-secured.js').then(m => m.default),
    'virtual-server-stack-unsecured': await import('./standard/virtual-server-stack-unsecured.js').then(m => m.default),
    'virtual-server-stack': await import('./standard/virtual-server-stack.js').then(m => m.default),
    'virtual-server-unsecured': await import('./standard/virtual-server-unsecured.js').then(m => m.default),
    'virtual-server': await import('./standard/virtual-server.js').then(m => m.default),
    'virtual-storage-stack': await import('./standard/virtual-storage-stack.js').then(m => m.default),
    'virtual-storage': await import('./standard/virtual-storage.js').then(m => m.default),
    'volume-mute': await import('./standard/volume-mute.js').then(m => m.default),
    'volume-up': await import('./standard/volume-up.js').then(m => m.default),
    'volumetric-flask': await import('./standard/volumetric-flask.js').then(m => m.default),
    'vulnerability': await import('./standard/vulnerability.js').then(m => m.default),
    'walk-arrow': await import('./standard/walk-arrow.js').then(m => m.default),
    'walk-shoe': await import('./standard/walk-shoe.js').then(m => m.default),
    'water-droplet': await import('./standard/water-droplet.js').then(m => m.default),
    'waveform': await import('./standard/waveform.js').then(m => m.default),
    'webhooks': await import('./standard/webhooks.js').then(m => m.default),
    'website-system': await import('./standard/website-system.js').then(m => m.default),
    'website': await import('./standard/website.js').then(m => m.default),
    'wheelchair-accessible': await import('./standard/wheelchair-accessible.js').then(m => m.default),
    'wifi': await import('./standard/wifi.js').then(m => m.default),
    'wind-power': await import('./standard/wind-power.js').then(m => m.default),
    'wind': await import('./standard/wind.js').then(m => m.default),
    'wrench': await import('./standard/wrench.js').then(m => m.default),
    'yen-decreasing': await import('./standard/yen-decreasing.js').then(m => m.default),
    'yen-increasing': await import('./standard/yen-increasing.js').then(m => m.default),
    'yen': await import('./standard/yen.js').then(m => m.default),
    'yes': await import('./standard/yes.js').then(m => m.default),
});
export const social = new IconSet({
    'email-square': await import('./social/email-square.js').then(m => m.default),
    'email': await import('./social/email.js').then(m => m.default),
    'facebook-square': await import('./social/facebook-square.js').then(m => m.default),
    'facebook': await import('./social/facebook.js').then(m => m.default),
    'flickr-square': await import('./social/flickr-square.js').then(m => m.default),
    'flickr': await import('./social/flickr.js').then(m => m.default),
    'github-square': await import('./social/github-square.js').then(m => m.default),
    'github': await import('./social/github.js').then(m => m.default),
    'google-square': await import('./social/google-square.js').then(m => m.default),
    'google': await import('./social/google.js').then(m => m.default),
    'instagram-square': await import('./social/instagram-square.js').then(m => m.default),
    'instagram': await import('./social/instagram.js').then(m => m.default),
    'linkedin-square': await import('./social/linkedin-square.js').then(m => m.default),
    'linkedin': await import('./social/linkedin.js').then(m => m.default),
    'messenger-square': await import('./social/messenger-square.js').then(m => m.default),
    'messenger': await import('./social/messenger.js').then(m => m.default),
    'microsoft-square': await import('./social/microsoft-square.js').then(m => m.default),
    'microsoft': await import('./social/microsoft.js').then(m => m.default),
    'rss-square': await import('./social/rss-square.js').then(m => m.default),
    'rss': await import('./social/rss.js').then(m => m.default),
    'stackoverflow-square': await import('./social/stackoverflow-square.js').then(m => m.default),
    'stackoverflow': await import('./social/stackoverflow.js').then(m => m.default),
    'threads-square': await import('./social/threads-square.js').then(m => m.default),
    'threads': await import('./social/threads.js').then(m => m.default),
    'twitch-square': await import('./social/twitch-square.js').then(m => m.default),
    'twitch': await import('./social/twitch.js').then(m => m.default),
    'wechat-square': await import('./social/wechat-square.js').then(m => m.default),
    'wechat': await import('./social/wechat.js').then(m => m.default),
    'weibo-square': await import('./social/weibo-square.js').then(m => m.default),
    'weibo': await import('./social/weibo.js').then(m => m.default),
    'whatsapp-square': await import('./social/whatsapp-square.js').then(m => m.default),
    'whatsapp': await import('./social/whatsapp.js').then(m => m.default),
    'x-square': await import('./social/x-square.js').then(m => m.default),
    'x': await import('./social/x.js').then(m => m.default),
    'youtube-square': await import('./social/youtube-square.js').then(m => m.default),
    'youtube': await import('./social/youtube.js').then(m => m.default),
});
export const microns = new IconSet({
    'arrow-down': await import('./microns/arrow-down.js').then(m => m.default),
    'arrow-left': await import('./microns/arrow-left.js').then(m => m.default),
    'arrow-right': await import('./microns/arrow-right.js').then(m => m.default),
    'arrow-up': await import('./microns/arrow-up.js').then(m => m.default),
    'caret-down-fill': await import('./microns/caret-down-fill.js').then(m => m.default),
    'caret-down': await import('./microns/caret-down.js').then(m => m.default),
    'caret-left-fill': await import('./microns/caret-left-fill.js').then(m => m.default),
    'caret-left': await import('./microns/caret-left.js').then(m => m.default),
    'caret-right-fill': await import('./microns/caret-right-fill.js').then(m => m.default),
    'caret-right': await import('./microns/caret-right.js').then(m => m.default),
    'caret-up-fill': await import('./microns/caret-up-fill.js').then(m => m.default),
    'caret-up': await import('./microns/caret-up.js').then(m => m.default),
    'checkbox-complete-fill': await import('./microns/checkbox-complete-fill.js').then(m => m.default),
    'checkbox-complete': await import('./microns/checkbox-complete.js').then(m => m.default),
    'checkbox-incomplete': await import('./microns/checkbox-incomplete.js').then(m => m.default),
    'checkmark': await import('./microns/checkmark.js').then(m => m.default),
    'close': await import('./microns/close.js').then(m => m.default),
    'external-link': await import('./microns/external-link.js').then(m => m.default),
    'search': await import('./microns/search.js').then(m => m.default),
});
//# sourceMappingURL=icons.js.map